/**
 * @generated SignedSource<<2242e7128755b781c99f2ad1c8164ba1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HeaderCellContainer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"InsertColumnButton">;
  readonly " $fragmentType": "HeaderCellContainer";
};
export type HeaderCellContainer$key = {
  readonly " $data"?: HeaderCellContainer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderCellContainer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "HeaderCellContainer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "InsertColumnButton"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "8c7ed6259e396b6167d470ec77da7fd5";

export default node;
